export default __webpack_public_path__ + "static/media/dalipro-iot.d78e3bf6.png";